import React from "react";
import logo from "../assets/logo.png";

function Navbar({ onLogoClick }) {
  return (
    <nav className="flex items-center justify-between w-full px-8 py-4 bg-white shadow">
      {/* Logo only */}
      <div className="cursor-pointer" onClick={onLogoClick}>
        <img src={logo} alt="PropMind Logo" className="h-24" />
      </div>

      {/* Right side links (optional, keep or remove) */}
      <div className="space-x-6 text-sky-800 font-semibold text-xl">
        <a href="#features" className="hover:text-sky-900">Features</a>
        <a href="#pricing" className="hover:text-sky-900">Pricing</a>
        <a href="#about" className="hover:text-sky-900">About</a>
      </div>
    </nav>
  );
}

export default Navbar;
